import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { MfaType } from '@ninety/platform/models/auth/mfaType.enum';
import { TotpActions } from '@ninety/platform/state/app-global/auth/auth.actions';
import { TerraIconModule } from '@ninety/terra';

import { LoginSharedStateFacade } from '../../_state/shared/login-shared-state.facade';

@Component({
  selector: 'ninety-trouble-getting-totp-code',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TerraIconModule],
  template: `
    <div class="totp-trouble-container">
      <div class="totp-trouble-card">
        <div class="header">
          <figure class="logo-wrapper">
            <img class="logo" [src]="loginState.displayLogo$ | async" alt="Login Logo" />
          </figure>
        </div>

        <div>
          <h2 class="totp-title">Trouble getting a code?</h2>
          <div class="totp-form-container">
            <p class="totp-subtitle">
              2-step verification has been enabled for this account. Please select the second way to verify your
              identity.
            </p>
            <div class="totp-by-container">
              <div class="totp-by-email" (click)="onSendCodeByEmail()">
                <div class="start">
                  <terra-icon class="flex-item" icon="lockkey" size="32"></terra-icon>
                </div>
                <div class="middle flex-item flex-center-item">
                  <p class="content-subtitle">Email</p>
                  <p class="content-body">Enter the one-time code sent to your email.</p>
                </div>
                <div class="end">
                  <terra-icon class="flex-item" icon="caret-right" size="32"></terra-icon>
                </div>
              </div>
              <span class="back-button-action">
                <button
                  secondary
                  outlined
                  class="ninety-cta-secondary back-button"
                  id="back-button"
                  data-product="auth__scan-qr-code-back-button"
                  data-cy="auth_scan-qr-code-back-button"
                  aria-label="Back to previous step"
                  (click)="onBack()">
                  Back
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./trouble-getting-code.component.scss'],
})
export class TroubleGettingCodeComponent {
  public readonly loginState = inject(LoginSharedStateFacade);
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  onSendCodeByEmail() {
    this.store.dispatch(TotpActions.openValidateCredentialsDialog({ mfaType: MfaType.EMAIL }));
  }

  onBack() {
    this.router.navigate(['totp']);
  }
}
